module.exports = __webpack_public_path__ + "static/media/plus_white.6038be0b.png";